<template>
  <div>
    <Toolbar />
    <v-layout class="d-flex flex-column mt-10 mx-5">
      <IconoHeader icono="file-search-outline" />
      <h4 class="texto-titulo font-weight-bold text-center mt-5">
        {{ titulo }}
      </h4>
      <p class="text-body-1 text-center grey--text text--darken-2 mt-2 mb-0">
        {{ subtitulo }}
      </p>
      <v-card class="mt-5 px-4 py-1 rounded-lg" elevation="2">
        <v-list-item>
          <v-list-item-content>
            <p>Resumen de tu crédito</p>
            <v-subheader class="px-0 my-0 mt-3" style="height: 100%">
              MONTO SOLICITADO
            </v-subheader>
            <v-list-item-title class="text-h5 py-1">
              {{ montoMoneda(montoSolicitado) }}
            </v-list-item-title>
            <v-divider :inset="true" class="ml-1"></v-divider>
            <v-subheader class="px-0 my-0 mt-3" style="height: 100%">
              MONTO APROBADO
            </v-subheader>
            <v-list-item-title class="text-h4 font-weight-bold py-1">
              {{ montoMoneda(montoAprobadoBuro) }}
            </v-list-item-title>
            <v-divider :inset="true" class="ml-1"></v-divider>
          </v-list-item-content>
        </v-list-item>
      </v-card>
      <div
        class="
          d-flex
          flex-column flex-sm-row
          justify-center
          align-center
          mt-5
          mb-5
        "
      >
        <template v-if="esMontoReducido">
          <v-btn
            class="btn-buro mb-3 mb-sm-0 mr-sm-3"
            color="primary"
            text
            elevation="2"
            @click="regresar"
            >EDITAR MONTO<v-icon right light>mdi-arrow-left</v-icon></v-btn
          >
          <v-btn
            class="btn-buro"
            color="primary"
            elevation="2"
            @click="continuarConMontoNuevo"
            >CONTINUAR CON NUEVO MONTO<v-icon right light
              >mdi-check</v-icon
            ></v-btn
          >
        </template>
        <template v-else>
          <v-btn
            class="btn-buro mb-3 mb-sm-0 mr-sm-3"
            color="primary"
            text
            elevation="2"
            @click="aceptarMontoNuevo"
            >CONTINUAR CON EL MONTO ACTUAL<v-icon right light
              >mdi-check</v-icon
            ></v-btn
          >
          <v-btn
            class="btn-buro"
            color="primary"
            elevation="2"
            @click="regresar"
            >EDITAR A NUEVO MONTO</v-btn
          >
        </template>
      </div>
    </v-layout>
  </div>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import IconoHeader from '@/components/compartidos/IconoHeader.vue'
import { FormatoMonedaMixin } from '@/mixins/formateos/FormatoMoneda.mixin'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  name: 'ConfirmacionBuro',
  components: { Toolbar, IconoHeader },
  mixins: [FormatoMonedaMixin, InsertaLogMixin],
  computed: {
    montoSolicitado() {
      return this.$store.getters['credito/obtenerCredito'].monto.val
    },
    escenarioBuro() {
      return this.$store.getters['credito/obtenerEscenarioBuro']
    },
    montoAprobadoBuro() {
      return this.$store.getters['credito/obtenerMontoAprobadoBuro']
    },
    esMontoReducido() {
      return this.escenarioBuro === 3
    },
    nombreSocio() {
      return (
        this.$store.getters['persona/obtenerPersona'].datosPersonales
          .nombreBienvenida || ''
      )
    },
    titulo() {
      const saludo = this.nombreSocio ? `, ${this.nombreSocio}` : ''
      return this.esMontoReducido
        ? `Tenemos una actualización para ti${saludo}`
        : `¡Buenas noticias${saludo}!`
    },
    subtitulo() {
      return this.esMontoReducido
        ? 'Ajustamos el monto aprobado de tu crédito, pero seguimos aquí para apoyarte con tu solicitud.'
        : 'Tienes un monto mayor disponible para tu crédito.'
    },
  },
  mounted() {
    this.InsertaLog()
  },
  methods: {
    actualizarMontoASolicitar() {
      const credito = this.$store.getters['credito/obtenerCredito']
      credito.monto.val = this.montoAprobadoBuro
      this.$store.dispatch('credito/actualizarCredito', credito)
    },
    // Escenario monto mayor
    aceptarMontoNuevo() {
      this.actualizarMontoASolicitar()
      this.$router.push('/datosDomicilio')
    },
    // Escenario monto reducido
    continuarConMontoNuevo() {
      this.actualizarMontoASolicitar()
      this.$router.push('/datosDomicilio')
    },
    regresar() {
      this.$router.push('/editar-monto-buro')
    },
  },
}
</script>

<style scoped>
.v-divider--inset:not(.v-divider--vertical) {
  max-width: 100%;
}
.btn-buro {
  width: 100%;
  max-width: 320px;
}
@media (min-width: 600px) {
  .btn-buro {
    width: auto;
    max-width: none;
  }
}
</style>
